<section class="container content-studio">

    <div class="mt-3">
      <h1 class="mb-1">{{translateText('contentTypes.dppTemplates', 'DPP Vorlagen')}}</h1>
      <p style="font-family:'MyFont-Light';">{{translateText('contentTypes.dppTemplatesDescription', 'Lege eine neue oder importiere eine bestehende Vorlage.')}}</p>
    </div>

    <!--
    <header class="studio-heading">
      <div>
        <h1>DPP Vorlagen</h1>
        <p>Lege eine neue oder importiere eine bestehende Vorlage.</p>
      </div>
    </header>
    -->

  <div class="tab-toolbar my-4">
    <input #templateImportInput type="file" accept=".nvpt,.zip,.json,application/json" hidden (change)="importTemplateFile($event)">
    <div class="template-toolbar-actions">
      <button mat-button class="orange-button" (click)="createContentType()">
        <mat-icon>add</mat-icon>
        {{translateText('contentTypes.new_pass_template', 'Neue Vorlage')}}
      </button>
      <button mat-button class="secondary-gray-button template-import-button" (click)="templateImportInput.click()">
        <mat-icon>upload_file</mat-icon>
        {{translateText('contentTypes.importTemplate', 'Vorlage importieren')}}
      </button>
    </div>
    <div class="template-toolbar-search">
      <mat-form-field class="pt-3 m-2 mb-0 mt-0 search">
        <mat-label>{{'search_title' | translate}}</mat-label>
        <input
          matInput
          [value]="templateSearchTerm"
          (keyup)="onTemplateSearch($any($event.target).value)"
          placeholder="{{'search' | translate}}">
        <mat-icon matPrefix>search</mat-icon>
      </mat-form-field>
    </div>
  </div>

  @if (contentTypes.length) {
    <div class="grid-shell" (click)="onTemplateGridClick($event)">
      @for (locale of [gridLanguage]; track locale) {
      <ag-grid-angular
        appFitGridToViewport
        class="studio-grid"
        [theme]="theme"
        [rowData]="contentTypes"
        [columnDefs]="contentTypeColumns"
        [defaultColDef]="defaultColDef"
        [localeText]="agGridLocaleText"
        [pagination]="true"
        [paginationPageSize]="25"
        [paginationPageSizeSelector]="paginationPageSizeSelector"
        [masterDetail]="true"
        [detailCellRenderer]="detailCellRenderer"
        [detailRowHeight]="detailRowHeight"
        [rowHeight]="56"
        [headerHeight]="48"
        [animateRows]="true"
        [suppressCellFocus]="true"
        [overlayNoRowsTemplate]="overlayNoRowsTemplate"
        [quickFilterText]="templateSearchTerm"
        (rowClicked)="onContentTypeSelected($event)"
        (rowGroupOpened)="onDetailRowToggled($event)">
      </ag-grid-angular>
      }
    </div>
  } @else {
    <section class="empty-state">
      <div class="empty-icon"><mat-icon>account_tree</mat-icon></div>
      <div>
        <span class="empty-kicker">{{translateText('contentTypes.emptyDppTemplates', 'Noch keine DPP Vorlagen')}}</span>
        <h3>{{translateText('contentTypes.emptyDppTemplatesTitle', 'Starte mit der ersten DPP Vorlage')}}</h3>
        <p>{{translateText('contentTypes.emptyDppTemplatesDescription', 'Der Assistent hilft beim Namen, der Datenstruktur und der passenden Design Vorlage. Danach kannst du daraus DPPs erzeugen.')}}</p>
        <button mat-button class="orange-button" (click)="createContentType()"><mat-icon>play_arrow</mat-icon>{{translateText('contentTypes.start', 'Starten')}}</button>
      </div>
    </section>
  }
</section>
